module.exports = __webpack_public_path__ + "img/background_section4.d11ae4a3.svg";